import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { IUpdate } from 'interface/updates';
import { Fragment } from 'react';
import UpdateItem from './UpdateItem';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { markAllAsRead } from 'redux/updateNotifications/updateNotificationsSlice';
import { useAppDispatch } from 'hooks/redux';

interface IProps {
  updates: IUpdate[];
}

const useStyles = makeStyles((theme) => {
  return {
    preContent: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '8px 0 24px',
    },
    list: {
      maxHeight: 300,
      '@media (max-width: 600px)': {
        marginRight: -13,
        flexDirection: 'row-reverse',
        maxHeight: 'calc(100% - 95px)',
      },
      overflow: 'auto',
      marginRight: -14,
      '&::-webkit-scrollbar': {
        width: '6px',
        backgroundColor: '#F5F5F5',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#555',
        borderRadius: 10,
      },
    },
    empty: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      marginTop: 32,
      '& > svg': {
        width: 180,
        height: 'auto',
      },
    },
    markAllAsRead: {
      cursor: 'pointer',
      color: theme.defaultTheme.main_palette.dark,
      fontSize: 14,
      padding: 0,
      '&:hover': {
        background: 'initial',
      },
    },
  };
});

const Updates = ({ updates }: IProps) => {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const markAsRead = () => {
    dispatch(markAllAsRead());
  };

  return (
    <Fragment>
      <div id='notifications-tab-updates' className={classes.preContent}>
        <Typography variant='caption'>Atualização dos últimos 30 dias</Typography>
        <IconButton
          onClick={markAsRead}
          disabled={updates.every((u) => u.read) || updates.length < 1}
          className={classes.markAllAsRead}
        >
          <div>Marcar tudo como lido</div>
        </IconButton>
      </div>
      <div className={classes.list}>
        {updates.map((u) => (
          <UpdateItem key={u.id} update={u} />
        ))}
      </div>
      {updates.length < 1 && (
        <div className={classes.empty}>
          <SvgIcon name='empty' />
          <Typography>Você não tem atualizações</Typography>
        </div>
      )}
    </Fragment>
  );
};

export default Updates;
